module.exports = __webpack_public_path__ + "assets/97fe2b179f7a99da05c91cad445b4bff.mp3";